import { Button } from '~/components/button';
import Form from '~/components/form';
import Heading from '~/components/heading';
import InputError from '~/components/inputerror';
import InputWrapper from '~/components/inputwrapper';
import TextField from '~/components/textfield';
import { captureException } from '~/utils/sentry';
import { useRouter } from 'next/router';
import React from 'react';

interface CheckMailboxProps {
  email: string;
}

interface CodeEntryValues {
  code: string;
}

export const CheckMailbox: React.FC<CheckMailboxProps> = (props) => {
  let { email } = props;
  let router = useRouter();
  let [error, setError] = React.useState('');

  return (
    <div>
      <Heading>Check your mailbox</Heading>
      <p>We have sent you an email with a confirmation link, click the link to login.</p>
      <div className="flex items-center my-4">
        <div className="w-full bg-gray-200 mr-4" style={{ height: 2 }}></div>
        <div className="uppercase font-medium text-gray-600">or</div>
        <div className="w-full bg-gray-200 ml-4" style={{ height: 2 }}></div>
      </div>
      <div>
        <Heading appearance="subheading">Enter Code</Heading>
        <Form
          initialValues={{
            code: '',
          }}
          onSubmit={async (values: CodeEntryValues) => {
            try {
              let response = await fetch('/api/auth/handle-auth-code', {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json',
                },
                body: JSON.stringify({
                  email,
                  code: values.code,
                }),
              });

              if (!response.ok) {
                throw new Error('Invalid code');
              }

              // @ts-ignore
              window.location.href = router.query.redirectTo || '/';
            } catch (err) {
              console.error(err);
              captureException(err);
              setError('Invalid code');
            }
          }}
          onValidate={(values: CodeEntryValues) => {
            let res: any = {};
            if (values.code.length < 4) {
              res.code = 'Code should be at least 4 characters';
            }
            return res;
          }}
        >
          {({ inputs, submit, values, errors, touched, isSubmitting }) => {
            return (
              <div>
                <InputWrapper label="Code" error={errors['code']} touched={touched['code']}>
                  <TextField
                    placeholder="code"
                    value={values['code']}
                    error={touched['code'] && errors['code']}
                    onChange={inputs['code'].change}
                    onSubmit={submit}
                    disabled={isSubmitting}
                    onBlur={inputs['code'].blur}
                  />
                </InputWrapper>
                <div className="flex justify-end">
                  <Button appearance="primary" onPress={submit} isLoading={isSubmitting}>
                    Continue
                  </Button>
                </div>

                <InputError touched={true}>{error}</InputError>
              </div>
            );
          }}
        </Form>
      </div>
    </div>
  );
};
